import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { CONFIGURATION } from "helpers/viewContent";
import { FORMAT_TEXT_VALUE } from "helpers/common";
import { Link, useHistory } from "react-router-dom";
import {
  getWithoutPaginationList_,
  addData_,
} from "store/services/commonService";

//imported
import * as Path from "routes/paths";
import * as actions from "store/actions/index.js";
import { TIMEZONES } from "./constants";

const STRIPE_CONFIG_KEY = "stripe_config";
const DEFAULT_STRIPE_CONFIG = {
  mode: "sandbox",
  liveSecretKey: "",
  livePublishKey: "",
  sandboxSecretKey: "",
  sandboxPublishKey: "",
};

const STRIPE_CONFIG_FIELDS = [
  { key: "liveSecretKey", label: "Live Secret Key" },
  { key: "livePublishKey", label: "Live Publish Key" },
  { key: "sandboxSecretKey", label: "Sandbox Secret Key" },
  { key: "sandboxPublishKey", label: "Sandbox Publish Key" },
];

const isStripeConfig = (field) =>
  field?.type === 6 || field?.key === STRIPE_CONFIG_KEY;

const parseStripeConfig = (value) => {
  if (!value) {
    return { ...DEFAULT_STRIPE_CONFIG };
  }

  if (typeof value === "object") {
    return { ...DEFAULT_STRIPE_CONFIG, ...value };
  }

  try {
    return { ...DEFAULT_STRIPE_CONFIG, ...JSON.parse(value) };
  } catch (err) {
    return { ...DEFAULT_STRIPE_CONFIG };
  }
};

const stringifyStripeConfig = (value) => JSON.stringify(parseStripeConfig(value));

const normalizeConfigurationFields = (fields = []) =>
  fields.map((field) =>
    isStripeConfig(field)
      ? { ...field, value: stringifyStripeConfig(field.value) }
      : field
  );

const AddEdit = ({ dispatch, match }) => {
  const history = useHistory();
  const [isShow, setIsShow] = useState(false);
  const [fieldsValue, setFieldsValue] = useState([]);

  const handleChange = (index, newValue, newName) => {
    const updatedFields = [...fieldsValue];
    updatedFields[index].key = newName;
    updatedFields[index].value = newValue;
    setFieldsValue(updatedFields);
  };

  const handleStripeConfigChange = (index, key, newValue) => {
    const updatedFields = [...fieldsValue];
    const stripeConfig = parseStripeConfig(updatedFields[index]?.value);

    updatedFields[index] = {
      ...updatedFields[index],
      value: JSON.stringify({ ...stripeConfig, [key]: newValue }),
    };

    setFieldsValue(updatedFields);
  };

  //submit setting data
  const handleSubmit = async (event) => {
    try {
      event.preventDefault();
      // Log or send the data wherever you need
      // console.log('Form data:', fieldsValue);
      const configurationData = normalizeConfigurationFields(fieldsValue);
      let query = {
        value: JSON.stringify(configurationData),
        url: "configuration/add",
      };
      setIsShow(true);
      await dispatch(addData_(query));
      setIsShow(false);
    } catch (err) {
      setIsShow(false);
      console.log(err);
    }
  };

  async function getDataView() {
    try {
      let query = {
        url: "configuration/list",
      };
      dispatch(actions.persist_store({ loader: true }));
      let res = await dispatch(getWithoutPaginationList_(query));
      console.log(res, "configuration")
      setFieldsValue(normalizeConfigurationFields(res?.body || []));
      dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      dispatch(actions.persist_store({ loader: false }));
      console.log(err);
    }
  }
  useEffect(() => {
    getDataView();
  }, []);

  return (
    <>
      <Helmet title={CONFIGURATION.CURRENT_MODULE} />
      <div className="page-header">
        <h3 className="page-title">
          <span className="page-title-icon bg-gradient-primary text-white me-2">
            <i className="mdi mdi-settings menu-icon"></i>
          </span>
          {CONFIGURATION.CURRENT_MODULE}
        </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={Path.configuration_add}>
                {CONFIGURATION.CURRENT_MODULE}
              </Link>
            </li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-md-10">
          <form className="forms-sample" onSubmit={handleSubmit}>
            <div className="card">
              <div className="card-body">
                <p className="">
                  <h3>
                    <b>Match Setting</b>
                  </h3>
                </p>
                <div className="row">
                  {fieldsValue.length > 0 &&
                    fieldsValue.map((value, i) => {
                      return (
                        <>
                          {value.type === 0 ||
                            value.type == 1 ||
                            value.type == 7 ? (
                            <>
                              <div className="form-group col-md-6" key={i}>
                                <label htmlFor={`exampleInputName${i}`}>
                                  {FORMAT_TEXT_VALUE(value.key)}*
                                </label>
                                <input
                                  type={value?.field_type}
                                  className="form-control"
                                  id={`exampleInputName${i}`}
                                  placeholder=""
                                  name={`value${i}`} // You may want to adjust the name attribute
                                  onChange={(e) =>
                                    handleChange(i, e.target.value, value.key)
                                  }
                                  value={value?.value || ""}
                                />
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      );
                    })}
                </div>

                <hr />
                <p className="">
                  <h3>
                    <b>AWS Setting</b>
                  </h3>
                </p>
                <div className="row">
                  {fieldsValue.length > 0 &&
                    fieldsValue.map((value, i) => {
                      return (
                        <>
                          {value.type === 2 ? (
                            <>
                              <div className="form-group col-md-6" key={i}>
                                <label htmlFor={`exampleInputName${i}`}>
                                  {FORMAT_TEXT_VALUE(value.key)}*
                                </label>
                                <input
                                  type={value?.field_type}
                                  className="form-control"
                                  id={`exampleInputName${i}`}
                                  placeholder=""
                                  name={`value${i}`} // You may want to adjust the name attribute
                                  onChange={(e) =>
                                    handleChange(i, e.target.value, value.key)
                                  }
                                  value={value?.value || ""}
                                />
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      );
                    })}
                </div>
                <hr />
                <p className="">
                  <h3>
                    <b>Twilio Setting</b>
                  </h3>
                </p>
                <div className="row">
                  {fieldsValue.length > 0 &&
                    fieldsValue.map((value, i) => {
                      return (
                        <>
                          {value.type === 3 ? (
                            <>
                              <div className="form-group col-md-6" key={i}>
                                <label htmlFor={`exampleInputName${i}`}>
                                  {FORMAT_TEXT_VALUE(value.key)}*
                                </label>
                                <input
                                  type={value?.field_type}
                                  className="form-control"
                                  id={`exampleInputName${i}`}
                                  placeholder=""
                                  name={`value${i}`} // You may want to adjust the name attribute
                                  onChange={(e) =>
                                    handleChange(i, e.target.value, value.key)
                                  }
                                  value={value?.value || ""}
                                />
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      );
                    })}
                </div>
                <hr />
                <p className="">
                  <h3>
                    <b>MailGun Setting</b>
                  </h3>
                </p>
                <div className="row">
                  {fieldsValue.length > 0 &&
                    fieldsValue.map((value, i) => {
                      return (
                        <>
                          {value.type === 4 ? (
                            <>
                              <div className="form-group col-md-6" key={i}>
                                <label htmlFor={`exampleInputName${i}`}>
                                  {FORMAT_TEXT_VALUE(value.key)}*
                                </label>
                                <input
                                  type={value?.field_type}
                                  className="form-control"
                                  id={`exampleInputName${i}`}
                                  placeholder=""
                                  name={`value${i}`} // You may want to adjust the name attribute
                                  onChange={(e) =>
                                    handleChange(i, e.target.value, value.key)
                                  }
                                  value={value?.value || ""}
                                />
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      );
                    })}
                </div>
                <hr />
                <p className="">
                  <h3>
                    <b>Stripe Setting</b>
                  </h3>
                </p>
                <div className="row">
                  {fieldsValue.length > 0 &&
                    fieldsValue.map((value, i) => {
                      const stripeConfig = parseStripeConfig(value?.value);

                      return (
                        <>
                          {isStripeConfig(value) ? (
                            <>
                              <div className="form-group col-md-6" key={`stripe-mode-${i}`}>
                                <label htmlFor={`stripeMode${i}`}>
                                  Mode*
                                </label>
                                <select
                                  className="form-select"
                                  id={`stripeMode${i}`}
                                  name="stripeMode"
                                  value={stripeConfig.mode}
                                  onChange={(e) =>
                                    handleStripeConfigChange(i, "mode", e.target.value)
                                  }
                                >
                                  <option value="sandbox">Sandbox</option>
                                  <option value="live">Live</option>
                                </select>
                              </div>
                              {STRIPE_CONFIG_FIELDS.map((stripeField) => (
                                <div
                                  className="form-group col-md-6"
                                  key={`${stripeField.key}-${i}`}
                                >
                                  <label htmlFor={`${stripeField.key}${i}`}>
                                    {stripeField.label}*
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id={`${stripeField.key}${i}`}
                                    placeholder=""
                                    name={stripeField.key}
                                    onChange={(e) =>
                                      handleStripeConfigChange(
                                        i,
                                        stripeField.key,
                                        e.target.value
                                      )
                                    }
                                    value={stripeConfig[stripeField.key] || ""}
                                  />
                                </div>
                              ))}
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      );
                    })}
                </div>
                <hr />
                <h3>
                  <b>Admin Commission Settings</b>
                </h3>
                <div className="row">
                  {fieldsValue.length > 0 &&
                    fieldsValue.map((value, i) => {
                      return (
                        <>
                          {value.type === 5 ? (
                            <div className="form-group col-md-6" key={i}>
                              <label htmlFor={`exampleInputName${i}`}>
                                {FORMAT_TEXT_VALUE(value.key)}*
                              </label>
                              <input
                                type={value?.field_type}
                                className="form-control"
                                id={`exampleInputName${i}`}
                                placeholder=""
                                name={`value${i}`} // You may want to adjust the name attribute
                                onChange={(e) =>
                                  handleChange(i, e.target.value, value.key)
                                }
                                value={value?.value || ""}
                              />
                            </div>
                          ) : null}
                        </>
                      );
                    })}
                </div>
                <hr />
                <h3 className="mt-2">
                  <b>Coach Commission Settings</b>
                </h3>
                <div className="row">
                  {fieldsValue.length > 0 &&
                    fieldsValue.map((value, i) => {
                      if (value.type != 12) return;
                      return (
                        <div className="form-group col-md-6" key={i}>
                          <label htmlFor={`exampleInputName${i}`}>
                            {FORMAT_TEXT_VALUE(value.key)}*
                          </label>
                          <input
                            type={value?.field_type}
                            className="form-control"
                            id={`exampleInputName${i}`}
                            placeholder=""
                            name={`value${i}`} // You may want to adjust the name attribute
                            onChange={(e) => {
                              const matchFee = Number(fieldsValue.find((item) => item.key === "match_fee")?.value) || 0;
                              if (Number(e.target.value) <= matchFee) {
                                handleChange(i, e.target.value, value.key)
                              }
                            }}
                            value={value?.value || ""}
                          />
                        </div>
                      );
                    })}
                </div>
                <hr />

                <h3>
                  <b>App Version</b>
                </h3>
                <div className="row pt-2">
                  {fieldsValue.length > 0 &&
                    fieldsValue.map((value, i) => {
                      if (value.type != 8) return;
                      return (
                        <div className="form-group col-md-6" key={i}>
                          <label htmlFor={`exampleInputName${i}`}>
                            {FORMAT_TEXT_VALUE(value.key)}*
                          </label>
                          <input
                            type={value?.field_type}
                            className="form-control"
                            id={`exampleInputName${i}`}
                            placeholder=""
                            name={`value${i}`} // You may want to adjust the name attribute
                            onChange={(e) =>
                              handleChange(i, e.target.value, value.key)
                            }
                            value={value?.value || ""}
                          />
                        </div>
                      );
                    })}
                </div>

                <h3 className="mt-2">
                  <b>TimeZone</b>
                </h3>
                <div className="row pt-2">
                  {fieldsValue.length > 0 &&
                    fieldsValue.map((value, i) => {
                      if (value.type != 11) return;
                      return (
                        <div className="form-group col-md-6" key={i}>
                          <label htmlFor={`exampleInputName${i}`}>
                            {FORMAT_TEXT_VALUE(value.key)}*
                          </label>
                          <select
                            className="form-select"
                            name="timezone"
                            id={`exampleInputName${i}`}
                            value={value?.value || ""}
                            onChange={(e) => handleChange(i, e.target.value, value.key)}
                          >
                            <option value="" disabled>
                              Select Timezone
                            </option>
                            {TIMEZONES.map((timezone) => (
                              <option key={timezone.value} value={timezone.value}>
                                {timezone.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      );
                    })}
                </div>

                <button
                  type="submit"
                  disabled={isShow ? true : false}
                  className="btn btn-gradient-primary me-2"
                >
                  {isShow ? "Loading.." : "Update"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
const mapStateToPros = (state) => {
  return {};
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(AddEdit);
